/* eslint-disable max-lines */
import { FavoriteStar } from 'resources/icons';
import { IMarker } from 'types/interfaces';
import { TYPES_MARKERS, zoomMinimoAparicionCodigo, zoomMinimoAparicionStop, POI_DEFAULT_BACKGROUND } from './constants';
import SvgIcon from 'components/commons/icons/SvgIcon';
import Image from 'components/commons/image/Image';
import Ic_Location_White from 'resources/icons/Ic_Location_White.svg';
import Ic_Bus_white from 'resources/icons/Ic_Bus_white.svg';
import {ReactComponent as Ic_Location_blue} from 'resources/icons/Ic_Location_blue.svg';
import {ReactComponent as Ic_Flag} from 'resources/icons/Ic_Red_Flag.svg';
import Button from 'components/commons/buttons/button/Button';
import { ReactComponent as Ic_Info } from 'resources/icons/Ic_Informacion.svg';
import { ReactComponent as Ic_Bus } from 'resources/icons/Ic_Bus_white.svg';
import { ReactComponent as Ic_Euro } from 'resources/icons/Ic_euro.svg';
import { ReactComponent as Ic_Nav } from 'resources/icons/Ic_Navigation.svg';
import { ReactComponent as Ic_Star } from 'resources/icons/Ic_Star_white.svg';
import { ReactComponent as Ic_Map } from 'resources/icons/Ic_Map.svg';
import IC_arrow_direction from 'resources/icons/direction_arrow_up.png';

export const getIcon = (iconId, icons, type) => {
  if(iconId) {
    const src = icons.find((icon) => Number(icon.id) === Number(iconId) || String(icon.id) === String(iconId));
    return src?.contentFile || (type === TYPES_MARKERS.STOP ? Ic_Bus_white : Ic_Location_White);
  }
  return type === TYPES_MARKERS.STOP ? Ic_Bus_white : Ic_Location_White;
};

export const contentRenderMarker = (
  marker: IMarker,
  selectorTransportModes: any,
  selectorStopsFavorites: any,
  selectorPoisFavorites: any,
  selectorIcons: any,
  selectorCategories: any,
  zoom: number,
  selectorPoiCategoryIcons: any,
) => {
  switch (marker.type) {
    case 'STARTENDLINE':
      return (
        <div
          key={'st_' + marker.id}
          className='marker_STARTENDLINE'
          onClick={(e) => e.preventDefault()}
        >
          {marker.data.nombre}
        </div>
      );
    case 'CIRCLESTOP':
      return (
        <div
          key={'cs_' + marker.id}
          className='marker_CIRCLESTOP'
          onClick={(e) => e.preventDefault()}
          style={{
            borderColor: '#' + (marker.data.routeColor === 'FFFFFF' ? '000000' : marker.data.routeColor),
          }}
        >
          {/* AL HACER ZOOM */}
          {(zoom && Number(zoom) >= Number(zoomMinimoAparicionStop) && !marker?.selected) && <div className='circle-zoom-stop'>
              <div
                className={`default-marker ${marker?.selected ? '--selected' : ''}`}
                onClick={(e) => e.preventDefault()}
                >
                <SvgIcon ariaLabel='icono-bus' Icon={Ic_Bus} style={{ width: 22, height: 22 }}/>
                <span className='marker-text'>{marker?.data?.stopCode}</span>
                {/* verificamos si pertenece a favoritos*/}
                {selectorStopsFavorites.find((stopFav) => Number(stopFav.stopId) === Number(marker.id)) && (
                  <span className='icon-favorite'>
                    <FavoriteStar style={{ width: '18px', height: '18px' }} />
                  </span>
                )}
              </div>
            </div>}
            {
              (marker.data.first && !marker.selected && zoom < zoomMinimoAparicionStop) &&
              <div className='my-origin-point'>
                <div className='my-origin-point-card'>
                  <SvgIcon
                    ariaLabel='icono destino'
                    Icon={Ic_Location_blue}
                    style={{ width: '25px', height: '25px' }}
                  />
                  <p style={{ fontWeight: 600, fontSize: '12px' }}>{marker?.data.name}</p>
                </div>
            </div>
            }
            {
              (marker.data.last && !marker.selected && zoom < zoomMinimoAparicionStop) &&
              <div className='my-destination-point'>
                <div className='my-destination-point-card'>
                  <SvgIcon
                    ariaLabel='icono destino'
                    Icon={Ic_Flag}
                    style={{ width: '25px', height: '25px' }}
                  />
                  <p style={{ fontWeight: 600, fontSize: '12px' }}>
                    {marker.data.name}
                  </p>
                </div>
              </div>
            }
        </div>
      );

    case 'ARROW':
      return (
        <div
          key={'ar_' + marker.id}
          className='marker_ARROW'
          onClick={(e) => e.preventDefault()}
          style={{ backgroundColor: marker.data.routeColor, borderColor: '#051730' }}
        >
          <img src={IC_arrow_direction} alt='arrow_direction' />
          {marker.data.angulo}
        </div>
      );
    case TYPES_MARKERS.NOMINATIM:
      const iconId = marker?.['iconFav'];
      return (
        <div
          key={'nomi_' + marker.id}
          className={marker?.selected ? 'emt-poi --selected' : 'emt-poi'}
          id={`emt-point-${marker.id}`}
          onClick={(e) => {
            e.preventDefault();
            marker.onClick && marker.onClick();
          }}
          style={{ backgroundColor: marker?.data?.routeColor || POI_DEFAULT_BACKGROUND }}
        >
          {
            iconId
            ? <Image src={iconId} alt='arrow_direction' style={{width: '22px', height: '22px', filter:'brightness(0) invert(1)'}}/>
            : <img src={Ic_Location_White} alt='arrow_direction' style={{width: '22px', height: '22px'}}/>
          }

          {/* verificamos si pertenece a favoritos*/}
          {selectorPoisFavorites.find((poiFav) => poiFav.poiId === marker.id || poiFav.id === marker.id) && (
            <span className='icon-favorite'>
              <FavoriteStar style={{ width: '18px', height: '18px' }} />
            </span>
          )}
        </div>
      );
    case 'DIRECTION':
      return <div></div>;

    case TYPES_MARKERS.POI:
      const iconID = marker?.data?.iconPoiCategory?.iconId;
      const favIconId = marker?.['iconFav'];
      const customStyle: any = {
        '--main-color': marker?.data?.iconPoiCategory?.color || POI_DEFAULT_BACKGROUND,
      };
      return (
        <div
          className={`emt-poi${marker?.selected ? ' --selected' : ''}`}
          id={`emt-point-${marker.id}`}
          onClick={(e) => {
            e.preventDefault();
            marker.onClick && marker.onClick();
          }}
          style={customStyle}
        >
          <div className='top-info'>
            <div id='hour'>
              <Image
                className='marker-img'
                alt='icono-code-poi'
                src={favIconId || getIcon(iconID, [...selectorPoiCategoryIcons?.flat(), ...selectorIcons], TYPES_MARKERS.POI)}
                style={{ maxWidth: 22, maxHeight: 22 }}
              />
              {
                 marker.topName && (
                  <span id='topName'>{marker.topName}</span>
                )
              }
            </div>
            {marker.name && <span id='name'>{marker.name}</span>}
            <Button icon={Ic_Nav} height='38px' width='38px' />
          </div>

          <div className='info'>
            <p>{marker.description?.toLowerCase()}</p>
            <Button
              icon={Ic_Star}
              height='38px'
              width='38px'
              poi-background={marker.background}
              background={marker.background}
              style={{ border: 'solid 2.5px white' }}
            />
          </div>

          {/* verificamos si pertenece a favoritos*/}
          {selectorPoisFavorites.find((poiFav) => poiFav.poiId === marker.id || poiFav.id === marker.id) && (
            <span className='icon-favorite'>
              <FavoriteStar style={{ width: '18px', height: '18px' }} />
            </span>
          )}
        </div>
      );

    case 'oac-marker':
      return (
        <div
          className='oac-marker'
          id={`oac-marker-${marker.id}`}
          onClick={(e) => {
            marker.onClick && marker.onClick();
          }}
          style={{ background: marker.background }}
        >
          <div className='top-info'>
            <SvgIcon ariaLabel='icono-code-poi' Icon={Ic_Info} style={{ width: 22, height: 22 }} />
            <span id='name'>{marker.name}</span>
            <Button icon={Ic_Nav} height='38px' width='38px' />
          </div>
          <div className='info'>
            <p>{marker.description?.toLowerCase()}</p>
            <Button
              icon={Ic_Star}
              height='38px'
              width='38px'
              background={marker.background}
              style={{ border: 'solid 2.5px white' }}
            />
          </div>
          {/* verificamos si pertenece a favoritos*/}
          {selectorPoisFavorites.find((poiFav) => poiFav.poiId === marker.id) && (
            <span className='icon-favorite'>
              <FavoriteStar style={{ width: '18px', height: '18px' }} />
            </span>
          )}
        </div>
      );
    case 'emt-marker':
      return (
        <div
          className='emt-marker'
          id={`emt-marker-${marker.id}`}
          onClick={(e) => {
            marker.onClick && marker.onClick();
          }}
          style={{ background: marker.background }}
        >
          <div className='top-info'>
            <div id='hour'>
              <SvgIcon
                ariaLabel='icono-code-poi'
                Icon={Ic_Info}
                style={{ width: 22, height: 22 }}
              />
              <span>{'Emt Palma'}</span>
              {/* Hacer dinámico */}
            </div>
            <span id='name'>{marker.name}</span> {/* Cambiar por name */}
            <Button icon={Ic_Nav} height='38px' width='38px' />
          </div>

          <div className='info'>
            <p>{marker.description?.toLowerCase()}</p>
            <Button
              icon={Ic_Star}
              height='38px'
              width='38px'
              background={marker.background}
              style={{ border: 'solid 2.5px white' }}
            />
          </div>
          {/* verificamos si pertenece a favoritos*/}
          {selectorPoisFavorites.find((poiFav) => poiFav.poiId === marker.id) && (
            <span className='icon-favorite'>
              <FavoriteStar style={{ width: '18px', height: '18px' }} />
            </span>
          )}
        </div>
      );
    case 'emt-point':
      return (
        <div
          className={'emt-point'}
          id={`emt-point-${marker.id}`}
          onClick={(e) => {
            marker.onClick && marker.onClick();
          }}
          style={{ background: marker.background }}
        >
          <div className='top-info'>
            <div id='hour'>
              <SvgIcon
                ariaLabel='icono-code-poi'
                Icon={Ic_Euro}
                style={{ width: 20, height: 20 }}
              />
              <span>{'24h'}</span> {/* Hacer dinámico */}
            </div>
            <span id='name'>{marker.name}</span>
            <Button icon={Ic_Nav} height='38px' width='38px' />
          </div>

          <div className='info'>
            <p>{marker.description?.toLowerCase()}</p>
            <Button
              icon={Ic_Star}
              height='38px'
              width='38px'
              background={marker.background}
              style={{ border: 'solid 2.5px white' }}
            />
          </div>

          {/* verificamos si pertenece a favoritos*/}
          {selectorPoisFavorites.find((poiFav) => Number(poiFav.poiId) === Number(marker.id)) && (
            <span className='icon-favorite'>
              <FavoriteStar style={{ width: '18px', height: '18px' }} />
            </span>
          )}
        </div>
      );
    case 'emt-bazar':
      return (
        <div
          className='emt-bazar'
          id={`emt-bazar-${marker.id}`}
          onClick={() => alert('Hola')}
          style={{ background: marker.background }}
        >
          <div className='top-info'>
            <SvgIcon ariaLabel='icono-code-poi' Icon={Ic_Euro} style={{ width: 22, height: 22 }} />
            <span id='name'>{marker.name}</span>
            <Button icon={Ic_Nav} height='38px' width='38px' />
          </div>

          <div className='info'>
            <p>{marker.description?.toLowerCase()}</p>
            <Button
              icon={Ic_Star}
              height='38px'
              width='38px'
              className='my-overlay-fn'
              background={marker.background}
              style={{ border: 'solid 2.5px white' }}
              onClick={() => alert('Hola')}
            />
          </div>

          {/* verificamos si pertenece a favoritos*/}
          {selectorPoisFavorites.find((poiFav) => Number(poiFav.poiId) === Number(marker.id)) && (
            <span className='icon-favorite'>
              <FavoriteStar style={{ width: '18px', height: '18px' }} />
            </span>
          )}
        </div>
      );
    case 'group':
      return (
        <div className='marker-group' id={`marker-group-${marker.id}`}>
          <SvgIcon
            ariaLabel='icono-code-poi'
            Icon={Ic_Map}
            style={{ width: 22, height: 22, minHeight: 22, minWidth: 22 }}
          />
          <span id='name'>{marker.data.points.length}</span>

          {/* verificamos si pertenece a favoritos*/}
          {selectorPoisFavorites.find((poiFav) => poiFav.poiId === marker.id) && (
            <span className='icon-favorite'>
              <FavoriteStar style={{ width: '18px', height: '18px' }} />
            </span>
          )}
        </div>
      );
    default:
      const icon = getIcon(marker.iconId, selectorIcons, TYPES_MARKERS.STOP);
      const stopCode = marker?.stopCode || marker?.data?.stopCode || null;
      return (
        <div
          className={`default-marker ${marker?.selected ? '--selected' : ''}`}
          onClick={(e) => e.preventDefault()}
        >
          {/* TODO: Eliminar el filter en la clase marker-img una vez actualizado el icono en la api */}
          <Image
            alt={
              marker?.data?.iconMarkTransportId
                ? 'icono_transportMode_' + marker?.data?.iconMarkTransportId
                : 'icono_poiCategory_' + marker?.data?.iconPoiCategory?.iconMarkId
            }
            id={marker?.id?.toString()}
            className={'marker-img'}
            src={icon}
          />
          {zoom && zoom >= zoomMinimoAparicionCodigo && stopCode && (
            <span className='marker-text'>{stopCode}</span>
          )}
          {/* verificamos si pertenece a favoritos*/}
          {selectorStopsFavorites.find((stopFav) => Number(stopFav.stopId) === Number(marker.id)) && (
            <span className='icon-favorite'>
              <FavoriteStar style={{ width: '18px', height: '18px' }} />
            </span>
          )}
        </div>
      );
  }
};

/* AGRUPAR PARADAS */

export function generateClusterMarker(markers: Array<IMarker>, zoom: number, icon: any, fn?: any, DIST_BETWEEN_POINTS = 0.0005) {
  let filtered: Array<IMarker> = JSON.parse(JSON.stringify(markers));

  //TO CHANGE añadir condición del zoom cuando se tengan las latitudes y longitudes que tocan
  if (filtered.length > 0) {
    //array de liminación de marcadores finales
    let differences: Array<any> = [];
    let newMarkers: Array<any> = [];
    for (let i = filtered.length - 1; i > -1 && filtered.length > 0; i--) {
      if (filtered[i]) {
        let neighboursMarkerIndexes: Array<number> = [];
        let neighboursMarkerI: Array<any> = [];
        neighboursMarkerI.push(JSON.parse(JSON.stringify(filtered[i])));
        /* Se recorren todos los marcadores filtrados desde la posición del marcador actual, para calcular solo los elementos a partir de la diagonal principal de la matriz */
        for (let j = i - 1; j > -1 && filtered.length > 0; j--) {
          /* Se calcula la distancia Euclídea para cada punto */
          let distanceLat = Math.pow(filtered[i]?.position?.lat - filtered[j]?.position?.lat, 2);
          let distanceLon = Math.pow(filtered[i]?.position?.lng - filtered[j]?.position?.lng, 2);
          let valueDistance = Math.pow(distanceLat + distanceLon, 0.5);
          /* En caso de ser una distancia muy pequeña se guarda el elemento en la lista de vecinos y su índice */
          //TO CHANGE
          if (valueDistance < DIST_BETWEEN_POINTS) {
            neighboursMarkerI.push(JSON.parse(JSON.stringify(filtered[j])));
            neighboursMarkerIndexes.push(j);
          }
        }

        if (neighboursMarkerI.length > 1) {
          differences.push(filtered[i]);
          // const lengthTotalNeighbours = neighboursMarkerI.length;
          //se genera un nuevo marcador contenedor de otros y se añade en el array de nuevos marcadores
          const MARKER_CONTENT: IMarker = {
            id: parseInt(`${filtered[i]?.id}999${i}`),
            position: {
              lat: neighboursMarkerI[0].position.lat,
              lng: neighboursMarkerI[0].position.lng,
            },
            //latitude: neighboursMarkerI[0].location.latitude,
            //longitude: neighboursMarkerI[0].location.longitude,
            type: TYPES_MARKERS.GROUP,
            data: {
              name: 'grupo de marcadores',
              points: neighboursMarkerI,
            },
            onClick: () => fn(neighboursMarkerI),
            /* staticIcon:
              lengthTotalNeighbours - 2 >= containerIcons.length - 1
                ? containerIcons[containerIcons.length - 1]
                : containerIcons[lengthTotalNeighbours - 2], */
          };
          newMarkers.push(MARKER_CONTENT);

          //se eliminan los marcadores vecinos del array principal
          for (let k = 0; k < neighboursMarkerIndexes.length; k++) {
            filtered.splice(neighboursMarkerIndexes[k], 1);
          }
        }
      }
    }

    //se elimina el marcador principal de cada cluster
    for (let m = 0; m < differences.length; m++) {
      let indexOf = filtered.findIndex(
        (element: IMarker) =>
          element.id === differences[m]?.id && element.type === differences[m]?.type,
      );
      if (indexOf !== -1) {
        filtered.splice(indexOf, 1);
      }
    }
    //se añaden los nuevos marcadores containers
    filtered = filtered.concat(newMarkers);
  }

  return /* zoom < 18 ? filtered : markers */ filtered;
}
